import history from '../../../shared/history';

export const getGlobalSettingsWrapperCustomClassName = (): string => {
  if (history?.location?.pathname?.includes('dnc-list')) {
    return 'p-0';
  }
  if (history?.location?.pathname?.includes('admin-settings')) {
    return 'pr-0';
  }
  return '';
};
